import { CSSProperties } from 'react';

// Utils
import { combineClasses } from '@/utils/className';

interface CircleProps {
  centerX: number;
  centerY: number;
  radius: number;
  fill?: string;
  opacity?: number;
  className?: string;
  style?: CSSProperties;
  name?: string;
}

export const Circle = ({
  centerX,
  centerY,
  radius,
  fill,
  opacity = 1,
  className,
  style,
  name,
}: CircleProps) => (
  <div
    data-name={name}
    className={combineClasses('absolute rounded-full', className)}
    style={{
      left: centerX - radius,
      top: centerY - radius,
      width: radius * 2,
      height: radius * 2,
      backgroundColor: fill,
      opacity,
      ...style,
    }}
  />
);
